import { useEffect } from 'react';
import { resolveSeo } from '../config/seo.js';

export function usePageSeo(siteText, key) {
    useSeoMeta(resolveSeo(siteText, key));
}

export function useSeoMeta({ title, description, canonical }) {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = title;
        const previous = [];
        for (const [selector, tag, attributes, valueAttribute, value] of [
            ['meta[name="description"]', 'meta', { name: 'description' }, 'content', description],
            ['meta[property="og:title"]', 'meta', { property: 'og:title' }, 'content', title],
            ['meta[property="og:description"]', 'meta', { property: 'og:description' }, 'content', description],
            ['meta[property="og:url"]', 'meta', { property: 'og:url' }, 'content', canonical],
            ['meta[name="twitter:title"]', 'meta', { name: 'twitter:title' }, 'content', title],
            ['meta[name="twitter:description"]', 'meta', { name: 'twitter:description' }, 'content', description],
            ['link[rel="canonical"]', 'link', { rel: 'canonical' }, 'href', canonical],
        ]) {
            let element = document.head.querySelector(selector);
            const created = !element;
            if (created) {
                element = document.createElement(tag);
                for (const [name, attr] of Object.entries(attributes)) element.setAttribute(name, attr);
                document.head.appendChild(element);
            }
            previous.push({ element, created, valueAttribute, old: element.getAttribute(valueAttribute) });
            element.setAttribute(valueAttribute, value);
        }
        return () => {
            document.title = previousTitle;
            for (const { element, created, valueAttribute, old } of previous) {
                if (created) element.remove();
                else if (old === null) element.removeAttribute(valueAttribute);
                else element.setAttribute(valueAttribute, old);
            }
        };
    }, [title, description, canonical]);
}
